module.exports = {
  MIDAS: {
    INIT: {
      NUMBER: 10001,
      DESCRIPTION: 'Centinel API connection error on Init.'
    },
    START: {
      NUMBER: 10002,
      DESCRIPTION: 'Centinel API connection error on Start.'
    },
    COLLECT: {
      NUMBER: 10011,
      DESCRIPTION: 'Centinel API connection error on Collect.'
    },
    CONTINUE: {
      NUMBER: 10009,
      DESCRIPTION: 'Centinel API connection error on Continue.'
    },
    VALIDATE: {
      NUMBER: 10003,
      DESCRIPTION: 'Centinel API connection error on Validate.'
    },
    CONFIRM: {
      NUMBER: 10007,
      DESCRIPTION: 'Centinel API connection error on Confirm.'
    }
  },
  GENERAL: {
    NUMBER: 10004,
    DESCRIPTION: 'A general error has occurred.'
  },
  CONFIGURATION: {
    NUMBER: 10006
  },
  MALFORMED_JWT: {
    NUMBER: 10010,
    DESCRIPTION: 'Response malformed, unable to parse.'
  },
  USER_CANCELED: {
    NUMBER: 10011,
    DESCRIPTION: 'Canceled by user'
  },
  VALIDATION:{
    JWT:{
      MISSING:{
        NUMBER: 10005,
        DESCRIPTION: 'No JWT found. Please check your setup configuration.'
      }
    },
    RESPONSEJWT:{
      MISSING:{
        NUMBER: 10008,
        DESCRIPTION: 'No Cardinal Response JWT found. Please check your setup configuration.'
      }
    }
  },
  HOSTED_FIELDS: {
    NUMBER: 10012
  }
};


//////////////////
// WEBPACK FOOTER
// ./constants/errors.js
// module id = 31
// module chunks = 0 5 20